import { Response } from "@/shared/models/Response";
import axios from "axios";
import { EmailData } from "../models/EmailData";
import { EmailPagination } from "../models/EmailPagination";
import { EmailQuery } from "../models/EmailQuery";

export class EmailService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_NOTIFICATIONS_API}/email`;
  }

  async addEmail(emailData: EmailData) {
    const response = await axios.post(`${this.baseUrl}/add`, emailData);
    return response.data;
  }

  async editEmail(emailData: EmailData) {
    const response = await axios.put(`${this.baseUrl}/edit`, emailData);
    return response.data;
  }

  async getEmailListByFilter(
    query: EmailQuery
  ): Promise<Response<EmailPagination | void>> {
    const response = await axios.get(`${this.baseUrl}/list-by-filter`, {
      params: query
    });
    return response.data;
  }

  async getEmailById(id: string): Promise<Response<EmailData | void>> {
    const response = await axios.get(`${this.baseUrl}/${id}`);
    return response.data;
  }
}
